import React from 'react'
import { runbusiness } from '../../utils/assets';
import styles from "../../pages/pages.module.scss";
import "../../App.css";

import FrameCard from '../CommonCard';
import ButtonShapped from '../ButtonShapped';


const FinanceDepartmentSection = () => {
  return (
    <div className="bg-lighttheme">
      <section >
        <div className="container SectionMTopB">
          <div className="row">
            <div className="col-sm-12 text-center ">
              <div className={`${styles.sectionheading}`}>
                <ButtonShapped
                  text="Run your business"
                  type="primaryshaped"
                />
                <h3>An Entire<span> Finance Department</span><br />At The Cost Of An Intern</h3>
                <p style={{ color: "#8D67BD" }}>Managing your finances has never been easier</p>
              </div>
            </div>

            <div className="row g-4 m-0 justify-content-center">
              {runbusiness.map((section) => (
                <div key={section.id} className="col-xl col-sm-6 col-12">
                  <FrameCard>
                    <div className="section-card h-100">
                      <div className={styles.toolaHCardSection}>
                        <div className="section-section text-center">
                          <h6>{section.title}</h6>
                          <label className="mb-3">{section.content}</label>
                        </div>
                        <div className={styles.whitecard}>
                          <div className="special-section">
                            {section.subContent.map((item, index) => (
                              <div key={index} className="sub-item" >
                                {item.type === "text" && <p>{item.content}</p>}
                                {item.type === "component" && item.component}
                                {item.type === "list" && (
                                  <ul>
                                    {item.content.map((listItem, i) => (
                                      <li key={i}>{listItem}</li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FrameCard>
                </div>
              ))}
            </div>

            <div className="justify-content-center">

              <button className={`${styles.secondaryHBtn}`}>
                Transparent pricing
              </button>

            </div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default FinanceDepartmentSection;